<div class="">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">VIEW AS</h4>
      <button type="button" class="close headerClose" (click)="close()" >&times;</button>
    </div>
    <form #theForm="ngForm" name="theForm" (ngSubmit)="confirm()">
    <div class="modal-body" style="height: 200px;">
      <div class="dropdown positionRelative">
        <label>User Email</label>
        <input type="email" class="form-control" placeholder="Enter Email" name="opp_email" #opp_email="ngModel" [(ngModel)]="opportunity_useremail" class="state dropdown-toggle" type="text" (ngModelChange)="filterUsers()"
        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        [ngModelOptions]="{standalone: true}" required/>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
           >
            <a class="dropdown-item" *ngFor="let email of filterdOptions"
              (click) = "opportunity_useremail = email">
              {{email}}</a>
          </div>
        <div class="error" *ngIf="!opp_email.valid && (opp_email.touched || opp_email.dirty) && !toErrMsg">
          <span *ngIf="opp_email.errors.required">Please enter the email.</span>
        </div>
        <div class="error" *ngIf="toErrMsg">
          <span>{{toErrMsg}}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="text-align:right">
      <button type="button" class="btn cancel_btn width100 float-left" (click)="close()">Cancel</button>
      <button type="submit" class="btn action_btn width100" [disabled]="enableValidation(opportunity_useremail)">Save</button>
    </div>
  </form>
  </div>
</div>